/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class GoalActions extends Component {
  @service
  router;

  evidence = false;
  exemplar = false;
  comet = false;
  onRouteTransition() {}

  @action
  goToRoute(route, params) {
    this.onRouteTransition();
    this.router.transitionTo(route, ...params);
  }
}
